import React from 'react';
import { Drawer as MuiDrawer } from '@mui/material';

import Dropdown from '@/components/ui/Dropdown';
import { useUserDropdown } from './useUserDropdown';
import UserDropdownTrigger from './UserDropdownTrigger';
import UserProfileContent from './UserProfileContent';
import SignOutModal from './SignOutModal';

const UserDropdown = () => {
  const {
    // 状态
    isLogin,
    isMobile,
    userMetaData,
    playerPendingClaimRewards,
    signOutModal,
    drawerOpen,
    
    // 计算属性
    iconColor,
    container,
    theme,
    t,
    
    // 事件处理函数
    handleDrawerClose,
    handleLogout,
    handleLiveSupport,
    openSignOutModal,
    closeSignOutModal,
    setDrawerOpenState,
  } = useUserDropdown();

  const profileContentProps = {
    isLogin,
    userMetaData,
    theme,
    t,
    isMobile,
    onLiveSupport: handleLiveSupport,
    onLogout: handleLogout,
  };

  return (
    <>
      {isMobile ? (
        <>
          {/* 移动端触发器 */}
          <UserDropdownTrigger
            iconColor={iconColor}
            isOpen={drawerOpen}
            onClick={() => setDrawerOpenState(true)}
          />

          {/* 移动端抽屉 */}
          <MuiDrawer
            container={container}
            anchor="bottom"
            open={drawerOpen}
            onClose={handleDrawerClose}
            ModalProps={{
              keepMounted: false,
              sx: {
                '& .MuiPaper-root': {
                  background: theme.palette.bg.main,
                  borderTopLeftRadius: theme.spacing(2),
                  borderTopRightRadius: theme.spacing(2),
                  maxHeight: '80vh',
                  overflowY: 'auto',
                },
              },
            }}
          >
            <UserProfileContent
              {...profileContentProps}
              onClose={handleDrawerClose}
            />
          </MuiDrawer>
        </>
      ) : (
        /* 桌面端下拉菜单 */
        <Dropdown
          placement={'bottom-end'}
          triggerElement={({ open, onClick, anchorRef }) => (
            <UserDropdownTrigger
              iconColor={iconColor}
              isOpen={open}
              onClick={onClick}
              anchorRef={anchorRef}
            />
          )}
        >
          {({ handleClose }) => (
            <UserProfileContent
              {...profileContentProps}
              onClose={handleClose}
            />
          )}
        </Dropdown>
      )}

      {/* 退出确认模态框 */}
      <SignOutModal
        open={signOutModal}
        onClose={closeSignOutModal}
        onConfirm={handleLogout}
        playerPendingClaimRewards={playerPendingClaimRewards}
        t={t}
      />
    </>
  );
};

export default UserDropdown; 